import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
// import store from "store";
import styles from "./index.module.scss";
import XtLoading from "@/components/Xt/Loading";
import { Form, Input, message } from "antd";
import Upload from "./Upload";
import { deepClone } from "@/utils/method";
import { UploadFile } from "antd/lib/upload";
import { waitRes } from "@/utils/axios";
import {
  get_enterpriseQualificationList,
  post_enterpriseQualificationBatchSave,
  post_enterpriseQualificationBatchSaveDraft,
  put_enterpriseApply,
} from "@/api/xt-user";
import { Rule } from "antd/lib/form";
import XtBtntxt from "@/components/Xt/BtnTxt";
import useNextTick from "@/hooks/useNextTick";
interface P3Props extends BaseCompProps {
  attr?: any;
  enterpriseApplyId?: string;
  onStepChange?(step: number): void;
}
interface ListProps extends ObjAny {
  fileName?: string;
  filePath?: string;
  webUrl?: string;
}
interface QualificationProps extends ObjAny {
  type: number;
  list: ListProps[];
}
export interface FileItemProps extends ObjAny {
  uid: string;
  name: string;
  status: UploadFile["status"];
  url: string;
}
const { useForm } = Form;
const { useTranslation } = Hooks;
const initFormData = {
  1: [] as FileItemProps[],
  2: [] as FileItemProps[],
  3: [] as FileItemProps[],
  4: [] as FileItemProps[],
  5: [] as FileItemProps[],
  6: [] as FileItemProps[],
  7: [] as FileItemProps[],
  8: [] as ({ webUrl: string } & ObjAny)[],
  9: [] as FileItemProps[],
};
const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};
const P3: React.FC<P3Props> = ({ className, enterpriseApplyId, onStepChange }) => {
  const t = useTranslation();
  const nextTick = useNextTick();
  //const {isLogin} = store.user;
  const [formIns] = useForm();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(deepClone(initFormData));
  /** useEffect */
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    formIns.setFieldsValue({ ...formData });
  }, [formData]);
  /**method */
  const init = async () => {
    setLoading(true);
    const { data, err }: { data: QualificationProps[]; err?: string } = await waitRes(get_enterpriseQualificationList, { params: { enterpriseApplyId } });
    setLoading(false);
    if (err || !data) return;
    data.forEach((item) => {
      if (item.type == 8) {
        formData[item.type] = [{ webUrl: item.list[0]?.webUrl || "" }];
        return;
      }
      formData[item.type] = item.list.map((li, i) => ({
        uid: i,
        name: li.fileName,
        status: "done",
        url: li.filePath,
      }));
    });
  };
  /**useMemo */
  const uploadRules = useMemo(() => {
    return [
      {
        required: true,
        validator: (_rule, value) => {
          if (!value || !value.length) return Promise.reject("请上传文件");
          const bool = value.every((v: any) => v.status === "done");
          if (!bool) return Promise.reject("请上传符合条件的文件");
          return Promise.resolve();
        },
      },
    ] as Rule[];
  }, []);
  const onValuesChange = (changedValues: typeof initFormData) => {
    if (changedValues[8] && changedValues[8][0].webUrl) {
      formData[8] = changedValues[8];
      setFormData({ ...formData });
    }
  };

  const uploadChange = (fileList: FileItemProps[], type: number) => {
    formData[type] = [...fileList];
    setFormData({ ...formData });
    // nextTick(() => {
    //   formIns.validateFields([type]);
    // });
  };
  const onSaveDraft = async () => {
    setLoading(true);
    const { err } = await waitRes(post_enterpriseQualificationBatchSaveDraft, {
      errorPop: true,
      params: {
        enterpriseApplyId,
      },
      data: getApiData(),
    });
    setLoading(false);
    if (!err) message.success(t("ent.saveSuccess"));
  };
  const onSaveContinue = async () => {
    try {
      await formIns.validateFields();
      setLoading(true);
      const { err } = await waitRes(post_enterpriseQualificationBatchSave, {
        errorPop: true, params: { enterpriseApplyId }, data: getApiData()
      });
      setLoading(false);
      if (err) return;
      setLoading(true);

      toApply();
    } catch (error) {
      message.error(t("ent.errTip"));
    }
  };

  const toApply = async () => {
    const { err } = await waitRes(put_enterpriseApply, enterpriseApplyId || "");
    setLoading(false);
    if (err) return;
    onStepChange?.(4);
  };

  const getApiData = () => {
    let ary = [] as (ListProps & { type?: number })[];
    type KType = keyof typeof formData;
    for (const k in formData) {
      const key = +k as unknown as KType;
      const data = formData[key].map((item: FileItemProps | { webUrl: string; type?: number }) => {
        if (key !== 8) {
          const uploadItem = item as FileItemProps;
          return {
            type: key,
            fileName: uploadItem.name,
            filePath: uploadItem.url,
          };
        }
        return {
          type: key,
          ...item,
        };
      });

      ary = ary.concat(data);
    }
    return ary;
  };
  return (
    <div className={cx(styles["page-account-enterprise-p3"], className)}>
      <div className={styles["page-account-enterprise--title"]}>{t("ent.comFile")}</div>
      <Form name="p3Form" form={formIns} onValuesChange={onValuesChange} initialValues={formData}>
        <div className={styles["iSection"]}>
          <p>1、{t("ent.comQua1")}</p>
          <Form.Item name={1} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={1} fileList={formData[1]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQuaSign")}</li>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>2、{t("ent.comQua2")}</p>
          <Form.Item name={2} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={2} fileList={formData[2]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>3、{t("ent.comQua3")}</p>
          <Form.Item name={3} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={3} fileList={formData[3]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>4、{t("ent.comQua4")}</p>
          <Form.Item name={4} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={4} fileList={formData[4]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>5、{t("ent.comQua5")}</p>
          <Form.Item name={5} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={5} fileList={formData[5]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["10"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>6、{t("ent.comQua6")}</p>
          <Form.Item name={6} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={6} fileList={formData[6]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>7、{t("ent.comQua7")}</p>
          <Form.Item name={7} getValueFromEvent={normFile} valuePropName="fileList" rules={uploadRules}>
            <Upload type={7} fileList={formData[7]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQua7Tip")}</li>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p style={{ marginBottom: "10px" }}>8、{t("ent.comQua8")}</p>
          <Form.Item name={[8, 0, "webUrl"]} rules={[{ required: true, message: t("ent.plsInput") }]} wrapperCol={{ span: 10 }}>
            <Input placeholder={t("ent.comQua8Hold")} maxLength={50}></Input>
          </Form.Item>
          <ul style={{ marginTop: '10px' }}>
            <li>· {t("ent.comQua8Tip")}</li>
          </ul>
        </div>
        <div className={styles["iSection"]}>
          <p>9、{t("ent.comQua9")}</p>
          <Form.Item
            name={9}
            getValueFromEvent={normFile}
            valuePropName="fileList"
            rules={[
              {
                validator: (_rule, value) => {
                  if (!value || !value.length) return Promise.resolve();
                  const bool = value.every((v: any) => v.status === "done");
                  if (!bool) return Promise.reject("请上传符合条件的文件");
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Upload type={9} fileList={formData[9]} uploadChange={uploadChange} />
          </Form.Item>
          <ul>
            <li>· {t("ent.comQua9Tip")}</li>
            <li>· {t("ent.comQuaSizeLimit")}</li>
            <li>· {t("ent.comQuaCountLimit", ["2"])}</li>
          </ul>
        </div>

        <div className={styles["page-account-enterprise--btns"]}>
          <XtBtntxt className={styles["ghost"]} onClick={() => onStepChange && onStepChange(1)}>
            {t("ent.backPrev")}
          </XtBtntxt>
          <XtBtntxt className={styles["ghost"]} onClick={onSaveDraft}>
            {t("ent.saveDraft")}
          </XtBtntxt>
          <XtBtntxt onClick={onSaveContinue}>{t("ent.saveContinue")}</XtBtntxt>
        </div>
      </Form>

      {loading && <XtLoading />}
    </div>
  );
};
export default observer(P3);
